const API_BASE = (process.env.REACT_APP_API_URL || 'http://localhost:5056/api').replace(/\/$/, '');

async function request(path, { method = 'GET', body, token, query } = {}) {
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers.Authorization = `Bearer ${token}`;
  const qs = query
    ? '?' + Object.entries(query).filter(([_, v]) => v !== undefined && v !== '').map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`).join('&')
    : '';
  const res = await fetch(`${API_BASE}${path}${qs}`, {
    method, headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data?.error?.message || `HTTP ${res.status}`);
    err.code = data?.error?.code || `HTTP_${res.status}`;
    err.status = res.status;
    throw err;
  }
  return data;
}

export const archivesApi = {
  list:        (opts)        => request('/archives',                { query: opts }),
  getBySlug:   (slug)        => request(`/archives/${encodeURIComponent(slug)}`),
  adminList:   (token, opts) => request('/admin/archives',          { token, query: opts }),
  adminGet:    (token, id)   => request(`/admin/archives/${id}`,    { token }),
  adminCreate: (token, body) => request('/admin/archives',          { method: 'POST',   token, body }),
  adminUpdate: (token, id, b)=> request(`/admin/archives/${id}`,    { method: 'PATCH',  token, body: b }),
  adminDelete: (token, id)   => request(`/admin/archives/${id}`,    { method: 'DELETE', token }),
};

export const ARCHIVE_TYPES = [
  { id: 'all',       lbl: 'Tout',         glyph: '◐' },
  { id: 'manuscrit', lbl: 'Manuscrits',   glyph: '✎' },
  { id: 'photo',     lbl: 'Photos',       glyph: '▣' },
  { id: 'audio',     lbl: 'Audio',        glyph: '♪' },
  { id: 'video',     lbl: 'Vidéos',       glyph: '▶' },
  { id: 'carte',     lbl: 'Cartes',       glyph: '⌖' },
  { id: 'texte',     lbl: 'Textes',       glyph: '☰' },
  { id: 'autre',     lbl: 'Autre',        glyph: '◌' },
];

export const ARCHIVE_LANGUAGES = [
  { id: 'all',   lbl: 'Toutes langues' },
  { id: 'fr',    lbl: 'Français' },
  { id: 'wo',    lbl: 'Wolof' },
  { id: 'ar',    lbl: 'Arabe' },
  { id: 'mixte', lbl: 'Multilingue' },
  { id: 'na',    lbl: 'Non applicable' },
];

export const TYPE_LABEL     = Object.fromEntries(ARCHIVE_TYPES.map((t) => [t.id, t.lbl]));
export const TYPE_GLYPH     = Object.fromEntries(ARCHIVE_TYPES.map((t) => [t.id, t.glyph]));
export const LANGUAGE_LABEL = Object.fromEntries(ARCHIVE_LANGUAGES.map((l) => [l.id, l.lbl]));
